import React, { useState, useContext } from "react"
import AuthScreen from "components/Auth/AuthScreen"
import styled from "@emotion/styled"
import { css } from "@emotion/core"
import Search from "../../Search"
import logo from "../../../../content/assets/drlogodark.svg"
import { Link } from "gatsby"
import CompanyWithIcon from "components/UI/CompanyWithIcon"
import FirebaseContext from "components/Common/FirebaseContext"
import SessionContext from "components/Common/SessionContext"
import AuthFunction from "components/Auth/AuthFunction"
import LightBox from "components/UI/LightBox"
import t, { mixin } from "theme"
import avatar from "../../../../content/assets/avatar.svg"
import LoadWithAuth from "components/UI/LoadWithAuth"
import Popup from "reactjs-popup"

//desktop top menu
const TopMenu = () => {
    const firebase = useContext(FirebaseContext)
    const session = useContext(SessionContext)

    return (
        <DesktopContainer>
            <Link to="/" state={{ bypassed: true }}>
                <DRLogo src={logo} alt="Disruption Research" />
            </Link>

            <LoadWithAuth
                signedIn={
                    <AvatarPopup
                        triggerComponent={
                            <img
                                src={avatar}
                                alt="avatar"
                                css={css`
                                    width: ${t.space[5]};
                                    display: block;
                                    margin-left: ${t.space[2]};
                                    cursor: pointer;
                                `}
                            />
                        }>
                        <div>{session && session.user ? session.user.email : null}</div>
                        <div
                            onClick={() =>
                                AuthFunction({
                                    firebase: firebase,
                                    session: session,
                                    command: "signout",
                                })
                            }
                            css={css`
                                cursor: pointer;
                            `}>
                            LOG OUT
                        </div>
                    </AvatarPopup>
                }
                signedOut={
                    <AuthScreen
                        mode="signin"
                        toggleComponent={
                            <div
                                css={css`
                                    font-size: ${t.font.size[3]};
                                    font-weight: ${t.font.weight.semibold};
                                    color: ${t.color.primary};
                                    cursor: pointer;
                                    margin-left: ${t.space[3]};
                                `}>
                                SIGN IN
                            </div>
                        }
                    />
                }
            />
        </DesktopContainer>
    )
}

export default TopMenu

const DesktopContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 100%;
`

const MobileContainer = styled.div`
    display: grid;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-items: center;
    grid-template-columns: 5.5rem 1fr 5.5rem;
    grid-template-rows: 1fr;
`

const DRLogo = styled.img`
    display: block;

    width: 250px;
    ${mixin.tabletandphonestyle} {
        width: 30vw;
    }
    ${mixin.phonestyle} {
        width: 45vw;
    }
`

/*
${mixin.phonestyle} {
        width: 100%;
    }
    */

const AvatarPopup = ({ triggerComponent, children }) => (
    <Popup trigger={open => triggerComponent} position="bottom center" closeOnDocumentClick>
        {children}
    </Popup>
)

/*
${mixin.phonestyle} {
    width: 45vw;
}*/
/*
<div
css={css`
    margin-left: ${t.space[4]};
`}>
{session && session.user ? session.user.email : "NOT LOGGED IN"}
</div>
<div>{firebase ? " FIREBASE ON" : " NO FIREBASE"}</div>
*/

/*
LOG OUT FUNCTION


<div
                                              onClick={() => {
                                               
                                              }}>
                                              LOGIN
                                          </div>



                                          */

/*
additional login/subscribe menu on mobile

 {loggedOut ? (
                            <>
                                <div
                                    css={css`
                                        cursor: pointer;
                                    `}
                                    onClick={() => {
                                        setAuthMode("signin")
                                        setAuthOpen(true)
                                    }}>
                                    LOGIN
                                </div>

                                <div
                                    css={css`
                                        cursor: pointer;
                                    `}
                                    onClick={() => {
                                        setAuthMode("signup")
                                        setAuthOpen(true)
                                    }}>
                                    SUBSCRIBE
                                </div>
                            </>
                        ) : null}

                        */

/*
const MobileTopMenu = ({ commonData, selectedCompany, selectedFeature }) => {
    const companies = commonData.liveCompanies
    const firebase = useContext(FirebaseContext)
    const session = useContext(SessionContext)

    return (
        <div>
            <MobileContainer>
                <LightBox
                    toggleComponent={
                        <i
                            className="icon-doublehamburger"
                            css={css`
                                cursor: pointer;
                            `}
                        />
                    }
                    css={css`
                        justify-self: start;
                    `}>
                    <div
                        css={css`
                            font-size: ${t.font.size[10]};
                            > * {
                                margin-bottom: ${t.space[5]};
                            }
                        `}>
                        <div>
                            <Link to={`/about`}>ABOUT</Link>
                        </div>
                        <div>
                            RESEARCH
                            <div
                                css={css`
                                    margin-left: ${t.space[4]};
                                    margin-top: ${t.space[3]};
                                    padding-left: ${t.space[4]};
                                    border-left: 1px dotted ${t.color.border};
                                    > *:not(:last-child) {
                                        margin-bottom: ${t.space[3]};
                                    }
                                `}>
                                {companies.map((company, index) => (
                                    <div>
                                        <Link to={`/stock/${company.ticker.toLowerCase()}`}>
                                            <CompanyWithIcon company={company} size={t.font.size[9]} />
                                        </Link>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </LightBox>
                <Link
                    to="/"
                    state={{ bypassed: true }}
                    css={css`
                        justify-self: center;
                    `}>
                    <DRLogo src={logo} alt="Disruption Research" />
                </Link>
                <div
                    css={css`
                        display: flex;
                        justify-self: end;
                    `}>
                    <LoadWithAuth
                        signedIn={
                            <AvatarPopup
                                triggerComponent={
                                    <img
                                        src={avatar}
                                        alt="avatar"
                                        css={css`
                                            width: ${t.space[4]};
                                            display: block;
                                            cursor: pointer;
                                        `}
                                    />
                                }>
                                <div>{session && session.user ? session.user.email : null}</div>
                                <div
                                    onClick={() =>
                                        AuthFunction({
                                            firebase: firebase,
                                            session: session,
                                            command: "signout",
                                        })
                                    }
                                    css={css`
                                        cursor: pointer;
                                    `}>
                                    LOG OUT
                                </div>
                            </AvatarPopup>
                        }
                        signedOut={
                            <AuthScreen
                                mode="signin"
                                toggleComponent={
                                    <div
                                        css={css`
                                            font-size: ${t.font.size[1]};
                                            font-weight: ${t.font.weight.semibold};
                                            color: ${t.color.primary};
                                            cursor: pointer;
                                            margin-left: ${t.space[1]};
                                        `}>
                                        LOG IN
                                    </div>
                                }
                            />
                        }
                    />
                </div>
            </MobileContainer>
        </div>
    )
}
*/
